import { AppRouteProps } from "@bsm/component";
import { StudentHealthAndImmunisationContainer } from "./container/StudentHealthAndImmunisationContainer";

export const StudentHealthAndImmunisationRoutes: Array<AppRouteProps> = [
    {
        path: "healthAndImmunisation",
        element: <StudentHealthAndImmunisationContainer />,
    },
];